import React from 'react';
import './AboutSection.css';

function AboutSection() {
  return (
    <section className="about">
      <h2>🌾 About the Program</h2>
      <p>
        The L&B GenAI KrishiTech Training & Internship is a free, industry-led program designed for BTech/MTech students
        to gain real-world skills in Generative AI and Agriculture. We are an MSME-registered startup based in Chennai,
        empowering students and farmers across India through innovation and training.
      </p>
      <p>
        No prior coding experience is required! Students will learn how to build real GenAI-based solutions that are
        deployment-ready on platforms like Azure, AWS, and GCP.
      </p>
    </section>
  );
}

export default AboutSection;

